import { Group, Portal, Trigger } from '@radix-ui/react-dropdown-menu'

export const DropdownMenuGroup = Group
export const DropdownMenuTrigger = Trigger
export const DropdownMenuPortal = Portal
